<template>
  <facet-list-fi
    ref="facet"
    :name="facet.name"
    :elements="elements"
    :unit="facet.unit"
    class="fact-finder-text-facet"
    @close="$emit('close')"
    @change="change"
    @clear-selection="clearSelection"
  />
</template>

<script>
import { FacetListFi } from 'atoms';

export default {
  name: 'FactFinderTextFacet',
  components: {
    FacetListFi,
  },
  props: {
    facet: {
      type: Object,
      default: () => ({}),
    },
    unselectedFacet: {
      type: Object,
      default: null,
    },
  },
  emits: ['close', 'change'],
  computed: {
    elements() {
      const { elements } = this.unselectedFacet || this.facet;
      return elements.map((element) => ({
        name: element.text,
        key: `${element.text}${this.unselectedFacet ? '_r' : ''}`,
        associatedFieldName: this.facet.associatedFieldName,
        selected: this.isChecked(element),
        count: element.totalHits,
        disabled: element.disabled, // TODO
      }));
    },
  },
  methods: {
    close() {
      if (this.$refs.facet) {
        this.$refs.facet.close();
      } else {
        this.$emit('close');
      }
    },
    clearSelection() {
      this.facet.elements.forEach((element) => {
        this.$emit('change', {
          value: false,
          element: {
            ...element,
            selected: false,
          },
        });
      });
      this.close();
    },
    isChecked(element) {
      if (element.selectedBool) {
        return true;
      }
      if (this.unselectedFacet) {
        const elementInActualFacet = this.facet.elements.find(
          (actualElement) => actualElement.text === element.text,
        );
        return elementInActualFacet?.selectedBool;
      }

      return false;
    },
    isEnabled(element) {
      if (this.unselectedFacet) {
        return this.facet.elements.some((actualElement) => actualElement.name === element.name);
      }

      return element.recordCount > 0;
    },
    change({ value, element }) {
      const newFacet = {
        name: this.facet.name,
        elements: [
          ...this.facet.elements.filter(
            (facetElement) => facetElement.selected && facetElement.name !== element.name,
          ),
        ],
      };
      if (value) {
        newFacet.elements.push({
          associatedFieldName: element.associatedFieldName,
          name: element.name,
          selected: true,
        });
      }

      this.$emit('change', {
        value,
        element: {
          associatedFieldName: element.associatedFieldName,
          name: element.name,
          selected: value,
        },
      });
      this.close();
    },
  },
};
</script>

<style scoped src="./fact-finder-text-facet" />
